import { defaultSignupFormConfig } from '@gig/magic-jurisdictions/dist/configs';

var PAGCOR = /** @class */ (function () {
    function PAGCOR() {
    }
    PAGCOR.prototype.setup = function () {
        console.warn('PAGCOR jurisdiction started!');
    };
    PAGCOR.prototype.destroy = function () {
        console.warn('PAGCOR jurisdiction destroy!');
    };
    return PAGCOR;
}());
var pagcor = new PAGCOR();
function setup() {
    pagcor.setup();
}
function destroy() {
    pagcor.destroy();
}
function signUpFormConfig(nextButtonEnabled) {
    return defaultSignupFormConfig(nextButtonEnabled);
}

export { destroy, setup, signUpFormConfig };
